import { render } from "./StaffPageRow.vue?vue&type=template&id=93470f42"
import script from "./StaffPageRow.vue?vue&type=script&lang=js"
export * from "./StaffPageRow.vue?vue&type=script&lang=js"

import "./StaffPageRow.vue?vue&type=style&index=0&id=93470f42&lang=css"
script.render = render

export default script